import React from 'react';
import classNames from 'classnames';

import { forTemplate } from 'app/common/lib/util/i18n';

import styles from './PageHeader.less';

const format = forTemplate('enterprise_list_header_component');

interface PageHeaderProps {
  title: string;
  count?: number;
  totalCount?: number;
  isFiltering?: boolean;
  onShowAll?: () => void;
  sortComponent?: React.ReactNode;
  searchComponent?: React.ReactNode;
}

export const PageHeader = (props: PageHeaderProps) => {
  const {
    title,
    count,
    totalCount,
    isFiltering,
    onShowAll,
    sortComponent,
    searchComponent,
  } = props;

  const subtitle = totalCount && totalCount > 0 && (
    <div className={styles.subtitle}>
      {isFiltering
        ? format('showing-x-of-y', { count, total: totalCount })
        : format('total-count', { count: totalCount })}
    </div>
  );

  const sort = sortComponent && (
    <div className={styles.sort}>{sortComponent}</div>
  );

  const search = searchComponent && (
    <div className={styles.search}>{searchComponent}</div>
  );

  const showAll = isFiltering && (
    <a href="#" onClick={onShowAll} role="button" className={styles.showAll}>
      {format('show-all')}
    </a>
  );

  return (
    <>
      <div className={classNames(styles.listHeader, 'u-clearfix')}>
        <div className={styles.title}>
          <h2>{title}</h2>
          {subtitle}
          {sort}
          {showAll}
        </div>
      </div>
      {search}
    </>
  );
};
